/*
 * Copyright (c) 2021 Mike Vo (info@miketvo.com) - All Rights Reserved.
 *
 * This file is part of the project "miketvo-website".
 *
 * This project is an online personal website by Mike Vo.
 *
 * COPYING AND/OR DISTRIBUTING OF ANY CONTENT WITHIN THIS PROJECT WITHOUT EX-
 * PRESS PERMISSION FROM THE CLIENT AND/OR THE AUTHOR, VIA ANY MEDIUM IS
 * STRICTLY PROHIBITED.
 *
 * Written by Mike Vo on June 27th 2021.
 *
 */

import * as React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";

import * as style from "./pagination.module.css";

const Pagination = ({ id, current, hasPrev, prev, hasNext, next, location, pages }) => {
  const openPageNumberMenu = () => {
    let openStyle =
      "display: -webkit-flex;" +
      "display: -moz-flex;" +
      "display: -ms-flex;" +
      "display: -o-flex;" +
      "display: flex;" +
      "transform-origin: bottom;" +
      "animation: slideInBottom 300ms;";
    document.getElementById(id).setAttribute("style", openStyle);
  };

  const closePageNumberMenu = () => {
    let menu = document.getElementById(id);
    let closeStyle =
      "display: -webkit-flex;" +
      "display: -moz-flex;" +
      "display: -ms-flex;" +
      "display: -o-flex;" +
      "display: flex;" +
      "transform-origin: top; animation: slideOutTop 300ms;";
    menu.setAttribute("style", closeStyle);
    setTimeout(() => {
      menu.setAttribute("style", "display: none;");
    }, 295);
  };

  const prevNav = () => {
    if (hasPrev)
      return (
        <Link to={location} state={{ pageIndex: prev }} className={style.button}>
          <img src={"/media/navigate_before_white_24dp.svg"} alt="Previous page" />
        </Link>
      );
    return (
      <div className={style.buttonInactive}>
        <img src={"/media/navigate_before_white_24dp.svg"} alt="Previous page" />
      </div>
    );
  };

  const nextNav = () => {
    if (hasNext)
      return (
        <Link to={location} state={{ pageIndex: next }} className={style.button}>
          <img src={"/media/navigate_next_white_24dp.svg"} alt="Next page" />
        </Link>
      );
    return (
      <div className={style.buttonInactive}>
        <img src={"/media/navigate_next_white_24dp.svg"} alt="Next page" />
      </div>
    );
  };

  return (
    <div className={style.wrapper}>
      {prevNav()}
      <div>
        <button className={style.pageNumber} onClick={openPageNumberMenu}>
          <div>{current + 1}</div>
        </button>
        <div id={id} className={style.pageNumberMenu} onClick={closePageNumberMenu}>
          <ul>
            {pages.map((page, index) => {
              if (current === index) {
                return (
                  <li className={[style.pageNumber, style.pageNumberActive].join(" ")}>
                    <Link to={location} state={{ pageIndex: index }}>
                      <div>{index + 1}</div>
                    </Link>
                  </li>
                );
              } else {
                return (
                  <li className={style.pageNumber}>
                    <Link to={location} state={{ pageIndex: index }}>
                      <div>{index + 1}</div>
                    </Link>
                  </li>
                );
              }
            })}
          </ul>
        </div>
      </div>
      {nextNav()}
    </div>
  );
};

Pagination.defaultProps = {
  id: "page-number-menu",
};

Pagination.propTypes = {
  id: PropTypes.string,
  current: PropTypes.number.isRequired,
  hasPrev: PropTypes.bool.isRequired,
  prev: PropTypes.number.isRequired,
  hasNext: PropTypes.bool.isRequired,
  next: PropTypes.number.isRequired,
  location: PropTypes.string.isRequired,
  pages: PropTypes.array.isRequired,
};

export default Pagination;
